import "./interface.scss";

import PropTypes from "prop-types";
import React from "react";

// May be replaced by Identifier
const IdentifierSlug = props => {
  return (
    <div className={`identifierSlug ${props.color}`} onClick={props.onClick}>
      {props.label}
    </div>
  );
};

IdentifierSlug.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string,
  onClick: PropTypes.func
};

export default IdentifierSlug;
